module.exports = "images/enfants_6.aaa94d0d.png";